define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const i18n = require('i18n');
    const commonLookupView = require('common/addressLookupSwiss/lookupControls/commonLookupView');

    require('widgets/autocomplete.widget');

    module.exports = commonLookupView.extend({

        onChangeSelectedItem: function() {
            const selectedItem = this.model.get('selectedItem');

            if (!selectedItem) {
                return;
            }

            this.$('.fn-lookup-input-text').val(this.sourceProvider.format(selectedItem));
            this.$('.fn-lookup-inner').forEach((field) => {
                const $inputs = $(field).find('input');
                const value = selectedItem[field.dataset.name];

                if (value) {
                    $inputs.val(value);
                    $(field).removeClass('fn-validate');
                    this.options.form.validateField(field);
                }
            });
        },

        onChangeHidden: function() {
            const hidden = this.model.get('hidden');
            const $fieldsContainer = this.$('.fn-fields-container');
            const $fieldsContainerSpecific = $('.fn-fields-container');

            // todo - still not good because of we specify element number manually here.
            if (!hidden) {
                $('.fn-action-manual').removeClass('address-lookup-hidden');
                $('.fn-action-reset').removeClass('address-lookup-hidden');
                $fieldsContainerSpecific[3].classList.remove('address-lookup-hidden');

                // Add 'disabled' to house field if NO streetName.
                const fieldsArr = window.document.getElementsByClassName('field-control__lookup');
                for (let i = 0; i < fieldsArr.length; i++) {
                    if (fieldsArr[i] && fieldsArr[i].querySelector('input').value === '') {
                        fieldsArr[i + 1] && fieldsArr[i + 1].querySelector('input').setAttribute('disabled', true);
                    }
                }
            } else {
                $fieldsContainerSpecific[3].classList.add('address-lookup-hidden');
            }

            $fieldsContainer.toggleClass('address-lookup-hidden', hidden);
            if ($fieldsContainer[0] && $fieldsContainer[0].querySelector('input')) {
                $fieldsContainer[0].querySelector('input').disabled = false;
            }
        },

        handleSearchResult: function(result) {
            if (result.errorCode === this.sourceProvider.NOT_VALID_ERROR || result.errorCode === this.sourceProvider.ABORT_ERROR) {
                this.model.set({
                    searchResult: []
                });

                return;
            }

            this.model.set({
                searchResult: result
            });

            if (result.errorCode === this.sourceProvider.NETWORK_ERROR) {
                $('.fn-action-manual').removeClass('address-lookup-hidden');

                this.model.set({
                    searchResult: {
                        errorCode: -1,
                        errorMessage: 'playtech.mobile.registration.addressLookupSwiss.serviceError.' + result.errorCode
                    }
                });

                return;
            }

            if (result.errorCode) {
                return this.handleSearchError(result);
            }

            this.model.set({
                searchResult: result
            });

            if (!result.length) {
                this.model.set({
                    searchResult: {
                        errorCode: 2,
                        errorMessage: "playtech.mobile.registration.addressLookup.serviceError.2"
                    }
                });

                return;
            }

            const prevResult = this.model.get('searchResult');

            this.options.form.resetField(this.$('.fn-lookup'));

            // should trigger change in any case if exist
            if (_.isEqual(prevResult, result)) {
                this.model.trigger('change:searchResult');
            }
        },

        handleSearchError: function(error) {
            const { errorCode, errorMessage } = error;

            if (errorCode === this.sourceProvider.ABORT_ERROR) {
                this.model.set({
                    searchResult: null
                });

                return;
            }

            this.model.set({
                searchResult: []
            });

            const defaultError = i18n.t('playtech.mobile.registration.addressLookupSwiss.serviceError.default');
            const errorTK = 'playtech.mobile.registration.addressLookupSwiss.serviceError.' + errorCode;
            const message = i18n.tExt(errorTK, errorMessage || defaultError);

            this.showError(message);
        },

        enableManualInput: function() {
            let lookUpForm = window.document.getElementsByClassName('form')[1];
            const inputIdsArray = ['zip', 'city'];
            this.model.set({
                hidden: false,
                showInnerFields: true,
                disableInnerFields: false
            });

            inputIdsArray.forEach((item) => {
                if (window.document.getElementById(item) && window.document.getElementById(item).value !== '') {
                    let currentItem = $('#' + item);
                    let newInput = window.document.createElement('input');
                    currentItem.attr('disabled', true);
                    newInput.type = 'hidden';
                    newInput.name = item;
                    newInput.value = currentItem.val();
                    lookUpForm && lookUpForm.appendChild(newInput);
                }
            });
        },

        onTextFocusout: function() {
            this.$el.find('.fn-lookup-input-text').val('');
            setTimeout(() => {
                document.querySelector('.register-popup') && this.$('.fn-lookup-input-text')?.autocomplete('focusOut');
            }, 200);
        },

        search: function(value) {
            const isGaps = /^\s/.test(value); // No gaps in string start.
            const prevSearchResult = this.model.get('prevSearchResult');
            const setResult = this.handleSearchResult.bind(this);
            const hideLoading = this.showLoading();

            if (isGaps) {
                return null;
            }

            this.sourceProvider.search(value, prevSearchResult)
                .then(setResult, setResult)
                .finally(hideLoading);
        }
    });
});
